// src/components/atoms/Dialog/index.tsx
import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import {
  Dialog as MuiDialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import styles from './dialog.module.css';
import Button from '@/components/atoms/Button';

interface DialogAction {
  label: string;
  onClick: () => void;
}

interface DialogProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  dialogActions?: DialogAction[];
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  fullScreen?: boolean;
  allowFullScreen?: boolean;
}

const OrgDialog: React.FC<DialogProps> = ({
  open,
  onClose,
  title,
  children,
  actions,
  dialogActions,
  maxWidth = 'sm',
  fullScreen: defaultFullScreen = false,
  allowFullScreen = false,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [isFullScreen, setIsFullScreen] = useState(defaultFullScreen);
  const ActionItems = dialogActions?.map((action, index) => (
    <Button key={index} onClick={action.onClick}>
      {action.label}
    </Button>
  ));
  // Reset fullscreen state when dialog closes
  useEffect(() => {
    if (!open) {
      setIsFullScreen(defaultFullScreen);
    }
  }, [open, defaultFullScreen]);

  const toggleFullScreen = () => {
    setIsFullScreen(prev => !prev);
  };
  // const closeButton = (
  //   <IconButton
  //     onClick={onClose}
  //     size="small"
  //     style={{
  //       position: 'absolute',
  //       top: 8,
  //       right: 8,
  //       color: 'grey',
  //     }}
  //   >
  //     <CloseIcon />
  //   </IconButton>
  // );
  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      fullScreen={isMobile || isFullScreen}
    >
      <div className={styles.modelCard}>
        {title && (
          <DialogTitle className={styles.dialogTitle}>
            {title}
            <div className={styles.dialogActions}>
              {allowFullScreen && !isMobile && (
                <IconButton
                  onClick={toggleFullScreen}
                  size="small"
                  className={styles.fullScreenButton}
                >
                  {isFullScreen ? <CloseFullscreenIcon /> : <OpenInFullIcon />}
                </IconButton>
              )}
              <IconButton onClick={onClose} size="small" className={styles.closeButton}>
                <CloseIcon />
              </IconButton>
            </div>
          </DialogTitle>
        )}

        <DialogContent className={styles.dialogContent}>{children}</DialogContent>

        {actions && <DialogActions className={styles.dialogActions}>{actions}</DialogActions>}
        {dialogActions && (!actions) && (
          <DialogActions className={styles.dialogActions}>
            {ActionItems}
          </DialogActions>
        )}
      </div>
    </MuiDialog>
  );
};

export default OrgDialog;
